import { useState, useEffect } from 'react'

// Hintergrund-Bilderwand: Spalten mit zufälligen Motiven, die endlos auf- und abwärts laufen.
// Einzelne Kacheln werden regelmäßig gegen neue Motive getauscht.

const PER_COLUMN = 6
const SWAP_INTERVAL = 2500 // ms

const randomSeed = () => Math.random().toString(36).slice(2, 10)
const imageUrl = seed => `https://picsum.photos/seed/${seed}/300/400`

function columnCount() {
  return Math.min(8, Math.max(3, Math.ceil(window.innerWidth / 220)))
}

function makeColumns(count) {
  return Array.from({ length: count }, () =>
    Array.from({ length: PER_COLUMN }, randomSeed)
  )
}

export default function ImageWall() {
  const [columns, setColumns] = useState(() => makeColumns(columnCount()))

  // Spaltenanzahl an Fensterbreite anpassen
  useEffect(() => {
    const onResize = () => {
      const count = columnCount()
      setColumns(cols => {
        if (cols.length === count) return cols
        return count < cols.length
          ? cols.slice(0, count)
          : [...cols, ...makeColumns(count - cols.length)]
      })
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  // Zufällige Kachel gegen ein neues Motiv tauschen – erst vorladen, dann einblenden
  useEffect(() => {
    const timer = setInterval(() => {
      if (document.hidden) return
      const seed = randomSeed()
      const img = new Image()
      img.onload = () => {
        setColumns(cols => {
          const c = Math.floor(Math.random() * cols.length)
          const i = Math.floor(Math.random() * PER_COLUMN)
          return cols.map((col, ci) =>
            ci === c ? col.map((s, si) => (si === i ? seed : s)) : col
          )
        })
      }
      img.src = imageUrl(seed)
    }, SWAP_INTERVAL)
    return () => clearInterval(timer)
  }, [])

  return (
    <div className="image-wall" aria-hidden="true">
      <div className="image-wall-grid">
        {columns.map((col, ci) => (
          <div
            key={ci}
            className={`image-wall-col ${ci % 2 ? 'down' : 'up'}`}
            style={{ animationDuration: `${60 + (ci % 3) * 15}s` }}
          >
            {/* Zweimal rendern für nahtlose Endlosschleife */}
            {[...col, ...col].map((seed, i) => (
              <img key={`${i}-${seed}`} src={imageUrl(seed)} alt="" loading="lazy" draggable="false" />
            ))}
          </div>
        ))}
      </div>
      <div className="image-wall-shade" />
    </div>
  )
}
